import { useSyncExternalStore } from "react";
import { canv } from "@/canv/global";
import type { VoteWindow } from "../../VoteWindow";
import { NewVoteController } from "../NewVoteController";

function useTimeCount(voteWindow: VoteWindow) {
    return useSyncExternalStore(voteWindow.subscribeTimeCount, voteWindow.getTimeCountSnapshot);
}

export function TimeController() {
    const timeCount = useTimeCount(canv.appInterface.voteWindow);

    const handleChange = (time: number) => {
        canv.appInterface.voteWindow.setTimeCount(timeCount + time);
    };

    const handleInputChange = (time: number) => {
        canv.appInterface.voteWindow.setTimeCount(time);
    };

    return (
        <NewVoteController
            name="Время"
            description="в минутах"
            count={timeCount}
            onChange={handleChange}
            onInputChange={handleInputChange}
        />
    );
}
